import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Budgeting } from 'pages/budgeting/Budgeting'

export const Route = createFileRoute('/budgeting/{-$siteID}')({
  component: BudgetingRouteComponent,
  staticData: {
    layout: {
      enableScrolling: true,
    },
  },
})

function BudgetingRouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <Budgeting />
}
